import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {BetWinMode} from "@nolimitcity/slot-game/bin/core/gametype/BetWinMode";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {ServerEvent} from '@nolimitcity/slot-game/bin/core/server/event/ServerEvent';
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpinEvent} from '@nolimitcity/slot-game/bin/core/spin/event/SpinEvent';
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
//import {Logger} from "@nolimitcity/slot-game/bin/core/utils/Logger";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {NudgeReelEvent} from "@nolimitcity/slot-game/bin/game/reel/nudgereel/NudgeReelEvent";
import {NudgeSpinReelController} from "@nolimitcity/slot-game/bin/game/reel/nudgereel/NudgeSpinReelController";
import {SpinReelEvent} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelEvent";
import {Elastic, TimelineLite, TweenLite} from "gsap";
import {BFGameEvent} from "../../events/BFGameEvent";
import {BarbarianFuryGameMode} from "../../gamemode/BarbarianFuryGameMode";
import {MultiplierIndicator} from "../../multiplier/MultiplierIndicator";
import {BarbarianFuryParsedGameData} from "../../server/data/BarbarianFuryParsedGameData";
import {BarbarianFurySoundConfig} from './../../BarbarianFurySoundConfig';
import {BarbarianFuryParsedInitData} from './../../server/data/BarbarianFuryParsedInitData';
import {BFWildSymbolWPView} from "./BFWildSymbolWPView";
import {BarbarianFuryGameConfig} from "../../BarbarianFuryGameConfig";

//import {BarbarianFuryStackedNudgeReelController} from "../nudgeStacked/BarbarianFuryStackedNudgeReelController";

export class BarbarianFuryWildNudgeWPController extends WinPresentationController {
    private NUDGE_STEP_SPEED:number = 0.4;

    private _nudgeData:BarbarianFuryParsedGameData | null;
    private _nudgeState:boolean[];
    private _nudgeSymbol:string[];
    private _steps:number[];
    private _nudgedSteps:number[];
    private _isNudging:boolean = false;
    private _currentMultiplier:number;
    private _nudgeAborted:boolean = false;
    private _scatterPositions:number[];
    private _finishTimeline:TimelineLite;
    private _view:BFWildSymbolWPView;
    private _gameMode:string = 'NORMAL';
    private _initReelSet:string[][];
    private _visibleReelSet:string[][];
    private _fullstackedReelIndexes:number[] = [];
    private roarSound:number = 0;
    private _winName:string | undefined = "";
    private _spinStarted:boolean = false;

    constructor(indexes:[number, number]) {
        super(indexes, {
            name : "BarbarianFury",
            betWinMode : BetWinMode.BET_LINE,
            skippable : true
        });

        this._view = new BFWildSymbolWPView();
        this.resetFeature();
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, NudgeReelEvent.NUDGE_STEP_COMPLETED, (event:GameEvent) => this.onNudgeStepCompeted(event.params[0]));
        EventHandler.addEventListener(this, NudgeReelEvent.NUDGE_STEP_START, (event:GameEvent) => this.playWildStepSound(event.params[0]));
        EventHandler.addEventListener(this, SpinReelEvent.REEL_STOP_SPIN_BOUNCE_STARTED, () => this.moveScatterOnTop());
        EventHandler.addEventListener(this, ScreenEvent.GAME_READY, () => this.moveReelOnTopOnSpinStart());
        EventHandler.addEventListener(this, "DIM_DOWN_WILD_MULTIPLIER", () => this._view.dimDownWildMultiplierOnScatterNudgeStart()); // #260
        EventHandler.addEventListener(this, ReelEvent.ALL_REELS_SPIN_STARTED, () => this.moveReelOnTopOnSpinStart());
        EventHandler.addEventListener(this, ReelEvent.ALL_REELS_SPIN_STOPPED, () => this.moveReelOnTopOnSpinStop());
        EventHandler.addEventListener(this, SpinEvent.START, () => {
            this._spinStarted = true;
            TweenLite.delayedCall(0.3, () => {
                SlotGame.sound.stopEffect(BarbarianFurySoundConfig.instance.WILD_BEAR_ROAR_SMALL + this.roarSound);
                SlotGame.sound.stopEffect(BarbarianFurySoundConfig.instance.WILD_BEAR_ROAR + this.roarSound);
            });
        });
        EventHandler.addEventListener(this, BFGameEvent.EXIT_FREESPIN, () => this.outOfFreeSpin());
        EventHandler.addEventListener(this, NudgeReelEvent.NUDGE_COMPLETED, (event:GameEvent) => this.onNudgeCompleted(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.showMulitplierOnRespinResore(event.params[0]));
        EventHandler.addEventListener(this, "PLAY_WILD_ROAR_SOUND", () => this.playWildRoarSound());
    }

    private _StepSoundCounter:number = 0;

    private playWildStepSound(reelId:number):void {
        if(!this._isNudging || (this._gameData!.betWins.length == 0 && this._gameMode === BarbarianFuryGameMode.NORMAL)) {
            return;
        }
        this._StepSoundCounter++;

        if(this._StepSoundCounter > 3) {
            this._StepSoundCounter = 1;
        }
        SlotGame.sound.playEffect(BarbarianFurySoundConfig.instance.WILD_NUDGE + this._StepSoundCounter);
    }

    private showMulitplierOnRespinResore(data:BarbarianFuryParsedInitData):void {
        let wildStackOverlay = data.overlayWildInRespin;
        let multiplier = (data as any).wildMultipliersInRespin;
        wildStackOverlay.forEach((val:boolean, index:number) => {
            if(wildStackOverlay[index]) {
                this._view.showMultiplierOnRestore(`x${multiplier[index]}`, index, true, true);
            }
        });

    }

    private moveReelOnTopOnSpinStart():void {
        for(let i = 4; i >= 0; i--) {
            Reels.getReel(i)!.view.parent.addChild(Reels.getReel(i)!.view);
        }
    }

    private moveReelOnTopOnSpinStop():void {
        for(let i = 4; i >= 0; i--) {
            let reelsSyms = Reels.getReel(i)!.allSymbols;
            for(let j:number = 0; j < reelsSyms.length; j++) {
                if(reelsSyms[j].symName.indexOf("W") > -1 || reelsSyms[j].symName.indexOf("S") > -1) {
                    Reels.getReel(i)!.view.parent.addChild(Reels.getReel(i)!.view);
                    break;
                }
            }
        }
    }

    protected parseFeatureGameData(data:BarbarianFuryParsedGameData):void {
        this.roarSound = 0;
        this._StepSoundCounter = 0;
        this._spinStarted = false;
        this._nudgeData = data;
        this._gameMode = data.mode;
        this._winName = data.currentWinRatioConfig!.text;
        this._initReelSet = this._nudgeData!.reels;
        this._visibleReelSet = [];

        for(let i = 0; i < this._initReelSet.length; i++) {
            for(let j = 0; j < this._initReelSet[i].length; j++) {
                let itemArray = this._initReelSet[i].slice(1, this._initReelSet[i].length - 1);
                this._visibleReelSet.push(itemArray);
                break;
            }
        }

        if(data.freeSpinMultiplier) {
            this._currentMultiplier = data.freeSpinMultiplier;
        }
        this._scatterPositions = data.scatterPositions != null ? data.scatterPositions : ArrayHelper.initArrayWithValues<number>(GameConfig.instance.REELS_NUM, () => {
            return -1
        });
    }

    protected hasWin():boolean {
        //Logger.logDev(`server data doReelNudge: ${this._nudgeData!.doReelNudge.toString()}`);
        return this._nudgeData!.doReelNudge.indexOf(true) > -1;
    }

    protected startWinPresentation():void {
        if((this._betWinsData != null && this._betWinsData.length > 0) || (this._gameMode.indexOf(BarbarianFuryGameMode.FREESPIN) > -1)) {
            this.NUDGE_STEP_SPEED = 0.4;
        } else {
            this.NUDGE_STEP_SPEED = 0.01;
        }

        this._isNudging = true;
        let delay:number = 0;
        EventHandler.dispatchEvent(new GameEvent(BFGameEvent.TOGGLE_MH_INNER_FIRE, true));
        this._nudgeData!.doReelNudge.forEach((doNudge:boolean, reelId:number) => {
            if(doNudge) {
                this.doReelNudge(reelId, delay);
                delay += Math.abs(this._steps[reelId]) * this.NUDGE_STEP_SPEED;
            }
        });
    }

    protected stopWinPresentation(isAborted:boolean):void {
        this._nudgeAborted = isAborted;
        if(this._finishTimeline && this._finishTimeline.isActive()) {
            this._finishTimeline.paused();
            this._finishTimeline.kill();
        }

        if(this._nudgeAborted) {
            for(let i:number = 0; i < this._nudgeData!.doReelNudge.length; i++) {
                if(this._nudgeData!.doReelNudge[i]) {
                    let nudgingSteps = this.getNudgingSteps(i),
                        xText = `x${nudgingSteps.toString()}`;

                    this._view.showMultiplier(xText, i, this._nudgeAborted);
                }
            }
        }

        this._isNudging = false;
        this._nudgeState.forEach((isNudging:boolean, reelId:number) => {
            if(isNudging) {
                this._nudgeAborted = true;
                // Abort don't send complete event so    it will not trigger onNudgeCompleted() again.
                (<NudgeSpinReelController>Reels.getReel(reelId)).abortNudge();
                this._nudgeState[reelId] = false;
                EventHandler.dispatchEvent(new GameEvent(BFGameEvent.STOP_WILD_FIRE_ANIM, true, reelId));
                EventHandler.dispatchEvent(new GameEvent("PLAY_WILD_ROAR_SOUND")); // #257
            }
        });
        if(this._nudgeAborted) {
            //  addded this check to set aborted true when user abort wild nudge and there is respin present
            if(this._gameData!.nextMode.indexOf("RESPIN") !== -1) {
                EventHandler.dispatchEvent(new GameEvent("SET_ABORTED_TRUE"));
            }
            // SlotGame.sound.playEffect(WildNudgeSoundConfig.instance.SCATTER_LANDING_2);
        }
        EventHandler.dispatchEvent(new GameEvent(BFGameEvent.TOGGLE_MH_INNER_FIRE, false));
        EventHandler.dispatchEvent(new GameEvent(MultiplierIndicator.UPDATE_MULTIPLIER, this._gameData!.currentMultiplier));
        // This is the first wp, so the startWP will always be triggered, no need to think about abort before start.
    }

    protected resetFeature():void {
        this._nudgeData = null;
        this._nudgeAborted = false;
        this._fullstackedReelIndexes = [];
        if(this._gameMode !== GameMode.FREESPIN) {
            this._currentMultiplier = 1;
        }
        this._steps = ArrayHelper.initArrayWithValues<number>(5, () => 0);
        this._nudgedSteps = ArrayHelper.initArrayWithValues<number>(5, () => 0);
        this._nudgeState = ArrayHelper.initArrayWithValues<boolean>(5, () => false);
        this._nudgeSymbol = ArrayHelper.initArrayWithValues<string>(5, () => "");
    }

    private moveScatterOnTop():void {
        for(let reelId:number = 1; reelId < 4; reelId++) {
            if(this._scatterPositions[reelId] === -1) {
                continue;
            }
            Reels.moveSymbolToTop(reelId, this._scatterPositions[reelId])
        }
    }

    private doReelNudge(reelId:number, delay:number):void {
        this._nudgeState[reelId] = true;
        const symbols:string[] = this._gameData!.reels[reelId];

        if(this.tryNudge("W", 0, reelId, symbols, delay) || this.tryNudge("W", 3, reelId, symbols, delay)
            || (this._nudgeData!.stackedSpinTriggered && (this.tryNudge(this._nudgeData!.activeStackedSymbol, 0, reelId, symbols, delay) || this.tryNudge(this._nudgeData!.activeStackedSymbol, 3, reelId, symbols, delay)))) {
            return;
        }

        debugger;
        throw new Error(`NudgeWildWPController.doReelNudge():There is no W or X->${this._nudgeData!.activeStackedSymbol} in a nudging reel. reelId = ${reelId}, symbols = ${symbols.toString()}`);
    }

    private tryNudge(symbol:string, stackIndex:number, reelId:number, reelSymbols:string[], delay:number):boolean {
        let index:number = reelSymbols.indexOf(`${symbol}*${stackIndex.toString()}`);
        if(MathHelper.isInRange(index, 1, 4)) {
            if(symbol === "W") {
                if(this._nudgeData!.overlayWilds == null || this._nudgeData!.overlayWilds![reelId].indexOf(false) > -1) {
                    debugger;
                    //Logger.logDev(`NudgeWildWPController.tryNudge, reelId = ${reelId}, server data overlayWilds has false!`);
                }

            } else if(this._nudgeData!.stackOverlay == null || this._nudgeData!.stackOverlay[reelId].indexOf(false) > -1) {
                // debugger;
                //Logger.logDev(`NudgeWildWPController.tryNudge, reelId = ${reelId}, server data stackOverlay has false!`);
            }

            this._steps[reelId] = stackIndex + 1 - index;
            (<NudgeSpinReelController>Reels.getReel(reelId)).nudge(this._steps[reelId], this.NUDGE_STEP_SPEED, Elastic.easeIn.config(1.5, 1), delay);

            this._nudgeSymbol[reelId] = symbol;
            return true;
        }

        return false;
    }

    private onNudgeStepCompeted(reelId:number):void {
        let stepsCount:number;
        if(!this._nudgeState[reelId]) {
            return;
        }

        const steps:number = this._steps[reelId];
        if(steps > 0) {
            this._nudgedSteps[reelId]++;
        } else if(steps < 0) {
            this._nudgedSteps[reelId]--;
        } else {
            //TODO: ==0? error?
        }

        if(!this._nudgeAborted) {
            if(this._nudgeSymbol[reelId] === "W") {
                // SlotGame.sound.playEffect("wildBearRoar");
            } else {
                // SlotGame.sound.playEffect(WildNudgeSoundConfig.instance.RANDOM_FEATURE_NUDGE);
            }
        }

        stepsCount = this._nudgedSteps[reelId];

        if(Math.sign(stepsCount) != 0) {
            if(Math.sign(stepsCount) < 0) {
                stepsCount = -1 * stepsCount;
            }
        }
        stepsCount = stepsCount + 1;

        if(this._nudgeSymbol[reelId] === "W" && !(this._nudgeAborted)) {
            this._currentMultiplier++;
            this._view.showMultiplier(`x${stepsCount.toString()}`, reelId, this._nudgeAborted);
        }
    }

    /**
     * function to play wild roar sound
     */
    private playWildRoarSound():void {
        if(this._spinStarted) {
            return;
        }
        this.roarSound++;
        if(this.roarSound > 2) {
            this.roarSound = 1;
        }
        if(this._winName === "Tiny Win" || this._winName === "Small Win") {
            if (!BarbarianFuryGameConfig.instance.WIN_BELOW_STAKE) {
                SlotGame.sound.playEffect(BarbarianFurySoundConfig.instance.WILD_BEAR_ROAR_SMALL + this.roarSound);
            }
        } else {
            SlotGame.sound.playEffect(BarbarianFurySoundConfig.instance.WILD_BEAR_ROAR + this.roarSound);
        }
    }

    private onNudgeCompleted(reelId:number):void {
        if(!this._isNudging) {
            return;
        }
        this._finishTimeline = new TimelineLite();
        let isWildFullStacked:boolean = true;
        for(let i:number = 0; i < this._visibleReelSet[reelId].length; i++) {
            if(this._visibleReelSet[reelId][i].indexOf("W") === -1) {
                isWildFullStacked = false;
                break;
            }
        }

        // added  this._gameMode === BarbarianFuryGameMode.NORMAL to fix #108
        //  (!isWildFullStacked) &&  added this to make sure nudgeno win will not play if wild lands already full stacked.
        if(this._nudgeData!.betWins.length === 0 && this._gameMode === BarbarianFuryGameMode.NORMAL) {
            (!isWildFullStacked) && SlotGame.sound.playEffect(BarbarianFurySoundConfig.instance.WILD_NUDGE_NO_WIN);
        }

        if(!isWildFullStacked) {
            const timeline:TimelineLite = new TimelineLite({paused : true});
            if((this._gameMode === BarbarianFuryGameMode.NORMAL && this._gameData!.betWins.length > 0) || this._gameMode === BarbarianFuryGameMode.FREESPIN) {
                timeline.add(() => {
                    EventHandler.dispatchEvent(new GameEvent(BFGameEvent.STOP_WILD_FIRE_ANIM, true, reelId));
                    EventHandler.dispatchEvent(new GameEvent("PLAY_WILD_ROAR_SOUND"));
                }, 0.5);
            } else if(((this._gameMode === BarbarianFuryGameMode.NORMAL && this._gameData!.betWins.length === 0) || this._gameMode === BarbarianFuryGameMode.FREESPIN)) {
                EventHandler.dispatchEvent(new GameEvent(BFGameEvent.HIDE_WILD_FIRE));

            }
            timeline.play(0);
        } else {
            if(reelId === 1) {
                EventHandler.dispatchEvent(new GameEvent(BFGameEvent.SHOW_X1_MULTIPLIER, reelId));
                SlotGame.sound.playEffect("wildStackedMultiplier");
            } else {
                this._fullstackedReelIndexes.push(reelId);
                for(let i:number = 0; i < this._fullstackedReelIndexes.length; i++) {
                    this._finishTimeline.add(() => {
                        EventHandler.dispatchEvent(new GameEvent(BFGameEvent.SHOW_X1_MULTIPLIER, this._fullstackedReelIndexes[i]));
                        SlotGame.sound.playEffect("wildStackedMultiplier");
                        this._fullstackedReelIndexes.splice(i, 1);
                    }, this.NUDGE_STEP_SPEED / 4 + (0.2 * i));
                }
            }
        }


        this._nudgeState[reelId] = false;

        if(this._nudgeState.indexOf(true) > -1) {
            return;
        }

        this._finishTimeline.add(() => {
            this.roarSound = 1;
            this.finish();
        }, this._nudgeSymbol[reelId] === "W" ? 1 : 0);

        this._finishTimeline.play();
    }

    private outOfFreeSpin():void {
        this._currentMultiplier = 1;
    }

    protected getNudgingSteps(reelId:number):number {
        let nudgingsteps = [...this._steps];
        let negativesSteps = nudgingsteps.filter(e => e < 0);
        for(let i:number = 0; i < negativesSteps.length; i++) {
            nudgingsteps[nudgingsteps.indexOf(negativesSteps[i])] = Math.abs(negativesSteps[i]);
        }

        for(let i:number = 0; i < this._nudgeData!.doReelNudge.length; i++) {
            if(this._nudgeData!.doReelNudge[i]) {
                nudgingsteps[i] = nudgingsteps[i] + 1;
            }
        }

        return nudgingsteps[reelId];
    }

}